import { SavedSearchModel, SavedSearchResponse } from 'types';
import genericNormalizer from './generic';

export const normalizeSavedSearch = genericNormalizer<
  SavedSearchResponse,
  SavedSearchModel
>(({ from }) => ({
  id: from('id'),
  name: from('name'),
  pos: from('pos'),
  query: from('query'),
}));



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/saved-search.ts